/* eslint-disable no-param-reassign */
import React, { FC, useEffect, useState } from 'react';
import { Button, Select } from '@cloudcar-app/cloudcar-components';
import { Row, Col, Switch } from 'antd';
import {
  CoverageType,
  Insurance,
  InsuranceSimulationProduct,
} from 'apollo/types';
import styles from './InsuranceFilters.module.scss';
import {
  coverageTypeValues,
  deducibleValues,
  insuranceFrecequencyValues,
} from './values';

interface InsuranceProduct extends InsuranceSimulationProduct {
  selected: boolean;
  disabled: boolean;
  show: boolean;
  coverageDetails: string;
}

interface InsuranceFiltersProps {
  insuranceProductsOption: InsuranceProduct[];
  setInsuranceProductsOption: React.Dispatch<
    React.SetStateAction<InsuranceProduct[]>
  >;
  proceduresInViewMode: boolean;
  insuranceData:
    | {
        getInsurance: Insurance;
      }
    | undefined;
}

const InsuranceFilters: FC<InsuranceFiltersProps> = (
  props: InsuranceFiltersProps,
) => {
  const {
    insuranceProductsOption,
    setInsuranceProductsOption,
    proceduresInViewMode,
    insuranceData,
  } = props;

  const [deductible, setDeductible] = useState<
    null | { [value: string]: string }[]
  >(null);

  const [coverageType, setCoverageType] = useState<null | CoverageType>(null);
  const [selectedAllOptions, setSelectedAllOptions] = useState(false);
  const [insuranceFrecequency, setInsuranceFrecequency] = useState<
    null | string
  >(null);

  const [coverageTypeOptions, setCoverageTypeOptions] = useState<
    | null
    | {
        value: string;
        label: string;
      }[]
  >(null);

  const enableInsuranceOptions = () => {
    const filteredInsuranceOptions = insuranceProductsOption.map((option) => {
      return {
        ...option,
        show: true,
      };
    });
    setInsuranceProductsOption(filteredInsuranceOptions);
  };

  const filterInsuranceOptions = () => {
    const filteredInsuranceOptions = insuranceProductsOption.map((option) => {
      let show = true;

      if (deductible && deductible.length > 0) {
        show =
          show &&
          deductible.length > 0 &&
          !!deductible.find(
            (value) => value.value === option.deductible.toString(),
          );
      }
      if (coverageType) {
        show = show && option.coverageType === coverageType;
      }
      if (insuranceFrecequency) {
        show = show && option.period === insuranceFrecequency;
      }

      return {
        ...option,
        show,
      };
    });
    setInsuranceProductsOption(filteredInsuranceOptions);
  };

  const setCoverageTypeOptionsFunction = () => {
    if (insuranceProductsOption) {
      const filteredOptions = coverageTypeValues.filter(
        (option) =>
          !!insuranceProductsOption.find(
            (product) => product.coverageType === option.value,
          ),
      );

      setCoverageTypeOptions(filteredOptions);
    }
  };

  useEffect(() => {
    const newInsuranceOptions = [...insuranceProductsOption];
    newInsuranceOptions.map((option) => {
      if (
        selectedAllOptions &&
        option.show &&
        (option.insuranceProvider === 'HDI' ||
          (option.insuranceProvider !== 'HDI' && option.PdfUrl))
      ) {
        option.selected = true;
      } else if (!selectedAllOptions) {
        option.selected = false;
      }
      return option;
    });
    setInsuranceProductsOption(newInsuranceOptions);
  }, [selectedAllOptions]);

  useEffect(() => {
    filterInsuranceOptions();
  }, [coverageType, deductible, insuranceFrecequency]);

  useEffect(() => {
    setCoverageTypeOptionsFunction();
  }, [insuranceProductsOption]);

  return (
    <>
      <Row style={{ marginBottom: '24px' }} gutter={[24, 24]}>
        <Col>
          <p> Seleccionar vigencia</p>
          <Select
            style={{ minWidth: '180px' }}
            showArrow
            isFilter
            allowClear
            onClear={enableInsuranceOptions}
            placeholder="Vigencia"
            value={insuranceFrecequency}
            onChange={(options: string) => {
              setInsuranceFrecequency(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                insuranceFrecequencyValues.find(
                  (value) => value.value === options,
                )?.value as string,
              );
            }}
            options={insuranceFrecequencyValues}
            compact
          />
        </Col>
        <Col>
          <p> Seleccionar deducible</p>
          <Select
            style={{ minWidth: '180px' }}
            showArrow
            isFilter
            allowClear
            onClear={enableInsuranceOptions}
            placeholder="Deducible"
            mode="tags"
            value={deductible?.map((value) => value.value)}
            onChange={(options: string[]) => {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              setDeductible(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                deducibleValues.filter((value) =>
                  options.includes(value.value),
                )!,
              );
            }}
            options={deducibleValues}
            compact
          />
        </Col>
        <Col>
          <p> Seleccionar cobertura</p>
          <Select
            style={{ minWidth: '180px' }}
            showArrow
            isFilter
            allowClear
            onClear={enableInsuranceOptions}
            placeholder="Cobertura"
            value={coverageType}
            onChange={(options: CoverageType) => {
              setCoverageType(
                coverageTypeOptions?.find((value) => value.value === options)
                  ?.value as CoverageType,
              );
            }}
            options={coverageTypeOptions || coverageTypeValues}
            compact
          />
        </Col>
        <Col>
          <p>&nbsp;</p>
          <Button
            onClick={() => {
              setCoverageType(null);
              setDeductible(null);
              setInsuranceFrecequency(null);
              enableInsuranceOptions();
            }}
          >
            Limpiar filtros
          </Button>
        </Col>
      </Row>
      {!(
        insuranceData?.getInsurance?.selectedInsuranceProducts &&
        insuranceData?.getInsurance?.selectedInsuranceProducts.length > 0
      ) && !proceduresInViewMode ? (
        <Row style={{ marginBottom: '36px' }} gutter={[24, 24]}>
          <Col xs={24}>
            <Row gutter={12} className={styles.FinancingSwitch}>
              <Col>
                <p>Seleccionar todas las opciones</p>
              </Col>
              <Col>
                <Switch
                  disabled={proceduresInViewMode}
                  checked={selectedAllOptions}
                  onChange={() => setSelectedAllOptions(!selectedAllOptions)}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default InsuranceFilters;
